import React from 'react';
import { Button, Space, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';
import { WiRaindrop } from 'react-icons/wi';
import { BiDetail } from 'react-icons/bi';
import { GrGraphQl } from 'react-icons/gr';
import { GiGroundSprout } from 'react-icons/gi';
import { useSelector } from 'react-redux';

const InfoBtns = ({ exploitationId, product}) => {
  const navigate = useNavigate();
  const userRole = useSelector((state) => state.user.userRole.name);

  const userLink = () => {
        if (userRole === 'client') {
          return '/client';
        } else if (userRole === 'admin' || userRole === 'superadmin') {
          return '/admin';
        } else if (userRole === 'domain_manager') {
          return '/domain-manager';
        } else if (userRole === 'exploitation_manager') {
          return '/exploitation-manager';
        }
      };

  let infoTypes = [
    { key: 'irrigation', label: 'Irrigation', icon: WiRaindrop, color: '#1890ff' },
    { key: 'detail', label: 'Détails', icon: BiDetail, color: '#52c41a' },
    { key: 'sol', label: 'Sol', icon: GiGroundSprout, color: '#eb2f96' },
    { key: 'graphe-combine', label: 'Graphe combiné', icon:GrGraphQl , color: '#722ed1' }
  ];

  if (!product.is_irrigation) {
    infoTypes = infoTypes.filter((type) => type.key !== 'irrigation' && type.key !== 'graphe-combine');
  }

  if (!product.is_soil) {
    infoTypes = infoTypes.filter((type) => type.key !== 'sol' && type.key !== 'graphe-combine');
  }

  if (userRole === 'client' || userRole === 'exploitation_manager' || userRole === 'domain_manager') {
    // if the user is not an admin, remove the 'graphe-combine' and 'detail' buttons
    infoTypes = infoTypes.filter((type) => type.key !== 'graphe-combine' && type.key !== 'detail');
  }


  const handleInfoClick = (infoType) => {
    navigate(`${userLink()}/exploitation/${exploitationId}/info/${infoType}`);
  };

  return (
    <Space size="small" wrap>
      {infoTypes.map((type) => (
        <Tooltip key={type.key} title={type.label}>
          <Button
            type="primary"
            icon={<type.icon style={{ fontSize: '24px' }} />}
            onClick={() => handleInfoClick(type.key)}
            style={{ backgroundColor: type.color, borderColor: type.color }}
            className="hover:opacity-80 transition-opacity duration-300"
          />
        </Tooltip>
      ))}
    </Space>
  );
};

export default InfoBtns;
